import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult, ReviewItem } from '../../types';

export default async function customOrderReview({ client, config }: Context,params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/review/list', config.api.url);
  const { data: { data }, data: res } = await client.post(url.href, params);
  if (data && data.list) {
    const reviews: ReviewItem[] = [];
    data.list.forEach((x) => {
      const review: ReviewItem = {
        reviewId: x.review_id,
        orderId: x.order_id,
        goodsId: x.goods_id,
        skuId: x.sku_id,
        grade: x.grade,
        reviewContent: x.review_content,
        nick: x.nick,
        createTime: x.create_time,
        imageUrl1: x.image_url_1,
        imageUrl2: x.image_url_2,
        imageUrl3: x.image_url_3,
        imageUrl4: x.image_url_4,
        imageUrl5: x.image_url_5,
        videoUrl: x.video_url
      };
      reviews.push(review);
    });
    res.data.list = reviews;
  }
  return res;
}
